import React, { useState, useEffect } from 'react';
import { _t, capitalize } from 'utils';
import Shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/local';
import { useSelector } from 'react-redux';
import useFilter from './hooks/nodepool-filters';
import CreateForm from './create';

export default ({
  nodepools = {}, clusterId, isActive = true, history,
}) => {
  const { listViewType = '' } = useSelector((e) => e);
  const [filters, setFilters] = useState({
    ramRange: [0, 100],
    coreRange: [0, 100],
    status: '',
    managedBy: '',
    searchText: '',
  });
  const [nodepoolsState, setNodepoolsState] = useState([]);
  const [filteredNodepools, FilterComponent] = useFilter({
    filters,
    setFilters,
    nodepools: nodepoolsState,
  });

  useEffect(() => {
    setNodepoolsState(nodepools);
  }, [nodepools]);

  const viewHandler = (id) => {
    history.push(`/kubernetes/${clusterId}/nodepool/${id}`);
  };

  return (
    <Shared.widgets.Cards
      title={_t('Node pools')}
      type="server"
      onSearch={(searchText) => setFilters((s) => ({ ...s, searchText }))}
      onFilter={() => setFilters((s) => ({ ...s, location: '' }))}
      filterRender={FilterComponent}
      addAction={ACTIONS_TYPES.KUBERNETES.NODEPOOL.CREATE}
      addRender={<CreateForm />}
      isEmpty={!filteredNodepools.length}
      isAdd={isActive}
    >
      {listViewType === 'table' ? (
        <Shared.widgets.TableView
          name="servers"
          rows={
            filteredNodepools.map((nodepool) => {
              const {
                id = '', properties = {}, metadata = {},
              } = nodepool;
              const {
                name,
                nodeCount,
                k8sVersion,
              } = properties;
              const { state = '' } = metadata;

              return ([
                <Shared.utilities.StatusLED state={state} />,
                {
                  value: name,
                  link: id,
                },
                k8sVersion,
                <span>
                  <Shared.widgets.Icon name="server" style={{ color: '#707070' }} />
                  <span style={{ marginLeft: 3, fontSize: 16 }}>{nodeCount}</span>
                </span>,
              ]);
            })
          }
          onCellClick={(id) => viewHandler(id)}
          columns={[
            { name: '' },
            { name: 'Name' },
            { name: 'Version' },
            { name: 'Nodes' },
          ]}
        />
      ) : (filteredNodepools.map((nodepool) => {
        const {
          id = '', properties = {}, metadata = {},
        } = nodepool;
        const {
          name,
          nodeCount,
          k8sVersion,
          maintenanceWindow = {},
        } = properties;
        const { dayOfTheWeek, time } = maintenanceWindow;
        const { state = '' } = metadata;

        return (
          <Shared.widgets.CardBasic
            key={id}
            onClick={() => viewHandler(id)}
            title={(
              <>
                {name}
                <Shared.utilities.Separator />
                {k8sVersion}
              </>
            )}
            icon="boxes"
            iconText="Nodepool"
            isLoader={!isActive}
            details={(
              <span style={{ fontSize: 14 }}>
                <Shared.utilities.StatusLED state={state} />
                <span style={{ marginLeft: 3 }}>{capitalize(state)}</span>
                <Shared.utilities.Separator />

                <Shared.widgets.Icon name="server" style={{ color: '#707070' }} />
                <span style={{ marginLeft: 3 }}>{`${nodeCount} Nodes`}</span>
                <Shared.utilities.Separator />

                <Shared.widgets.Icon name="clock" style={{ color: '#707070' }} />
                <span style={{ marginLeft: 3 }}>{time}</span>
                <Shared.utilities.Separator />

                <Shared.widgets.Icon name="calendar-day" style={{ color: '#707070' }} />
                <span style={{ marginLeft: 3 }}>{dayOfTheWeek}</span>
              </span>
            )}
          />
        );
      }))}
    </Shared.widgets.Cards>
  );
};
